import { httpClient } from '../http/httpClient'

export type MakeProposalRequest = {
  customerId: string
}

export type MakeProposalResponse = {
  sellerId: string
  customerId: string
  intermediaryId: string
  authorizationLink: string
  linkExpirationDate: string
  type: string
  _id: string
  createdAt: string
  updatedAt: string
  __v: number
}

export async function makeProposal(
  payload: MakeProposalRequest,
): Promise<MakeProposalResponse> {
  const { data } = await httpClient
    .post<MakeProposalResponse>('/pan', payload)
    .catch((error) => {
      throw error.response?.data ?? error
    })

  return data
}
